var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"classifier garbage"},[_c('e-toolbar',{attrs:{"items":_vm.items,"hideRemoveButton":true,"hideAddButton":true,"showTotal":true,"hideImportBtn":true}}),_c('e-table',{attrs:{"items":_vm.items,"showCheckbox":false,"actionColumnWidth":100,"showDeleteButton":false,"showEditButton":false}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }